import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import {
  AuthActions,
  BaseSiteService,
  OCC_USER_ID_CURRENT,
  StateWithClientAuth,
  UserIdService
} from '@spartacus/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { take } from 'rxjs/operators';
import { VscaOAuthLibWrapperService } from '../../core/auth/user-auth/service/vsca-oauth-lib-wrapper.service';
import * as config from '../shared/config/app.config';
import { BaseService } from '../shared/services/base.service';

@Injectable({
  providedIn: 'root',
})
export class CustomRegistrationService {
  public provinceData = new BehaviorSubject<any>(false);
  provinceData$ = this.provinceData.asObservable();
  public practiceOrFacilityTypeData = new BehaviorSubject<any>(false);
  practiceOrFacilityTypeData$ = this.practiceOrFacilityTypeData.asObservable();
  public contactTitleData = new BehaviorSubject<any>(false);
  contactTitleData$ = this.contactTitleData.asObservable();
  public contactRoleData = new BehaviorSubject<any>(false);
  contactRoleData$ = this.contactRoleData.asObservable();
  public contactOrderPlanData = new BehaviorSubject<any>(false);
  contactOrderPlanData$ = this.contactOrderPlanData.asObservable();
  public passwordRecoveryQuestionsData = new BehaviorSubject<any>(false);
  passwordRecoveryQuestionsData$ =
    this.passwordRecoveryQuestionsData.asObservable();
  public sectionChange = new Subject<{
    header: string;
    form?: FormGroup;
    forms?: FormGroup[];
    totalFormData?: any;
    msgData?: any;
  }>();

  authRedirectService: any;
  existUserInfo = new BehaviorSubject<any>(false);

  constructor(
    private readonly baseService: BaseService,
    private readonly oAuthLibWrapperService: VscaOAuthLibWrapperService,
    private readonly userIdService: UserIdService,
    private readonly store: Store<StateWithClientAuth>,
    private baseSiteService: BaseSiteService
  ) {
    this.baseSiteService.getActive().pipe(take(1)).subscribe(res => this.baseSiteId = res);
  }
  baseSiteId: string;

  public getProvinces(params): void {
    this.baseService.get(config.GET_PROVINCES, params).subscribe((res) => {
      this.provinceData.next(res);
    });
  }

  public getPracticeOrFacilityType(params): void {
    this.baseService
      .get(config.GET_PRACTICEORFACILITYTYPE, params)
      .subscribe((res) => {
        this.practiceOrFacilityTypeData.next(res.filter(obj => obj.name));
      });
  }

  public getContactTitle(params): void {
    this.baseService
      .get(config.GET_PRACTICEORFACILITYTYPE, params)
      .subscribe((res) => {
        this.contactTitleData.next(res);
      });
  }

  public getContactRole(params): void {
    this.baseService
      .get(config.GET_PRACTICEORFACILITYTYPE, params)
      .subscribe((res) => {
        this.contactRoleData.next(res);
      });
  }

  public getContactOrderPlan(params): void {
    this.baseService
      .get(config.GET_PRACTICEORFACILITYTYPE, params)
      .subscribe((res) => {
        this.contactOrderPlanData.next(res);
      });
  }
  
  public getPasswordRecoveryQuestions(params): void {
    this.baseService
      .get(config.GET_PRACTICEORFACILITYTYPE, params)
      .subscribe((res) => {
        this.passwordRecoveryQuestionsData.next(res);
      });
  }

  public getAccountData(params: any): Observable<any> {
    return this.baseService.post(
      'account/getAccountDetails',
      params
    );
  }

  public postAccountRegistration(params?: any): Observable<any> {
    return this.baseService.post(
      config.POST_ACCOUNT_REGISTRATION_DETAILS,
      params
    );
  }

  public postValidateAccountInfo(params?: any): Observable<any> {
    return this.baseService.post(
      config.VALIDATE_ACCOUNT_INFORMATION_USER_REGISTRATION,
      params
    );
  }

  public postUserRegistrationInfo(params?: any): Observable<any> {
    return this.baseService.post(config.POST_USER_REGISTRATION_INFO, params);
  }

  public getAddressValidation(obj: any): Observable<any> {
    //return this.baseService.post(config.VALIDATE_ADDRESS, obj);

    return this.baseService.post(config.VALIDATE_ADDRESS, obj);


  }

  loginWithCredentials(userId: string, password: string) {
    this.oAuthLibWrapperService
      .vscaAuthorizeWithPasswordFlowForbaseSiteId(userId, password, this.baseSiteId)
      .then((res) => {
        this.userIdService.setUserId(OCC_USER_ID_CURRENT);

        this.store.dispatch(new AuthActions.Login());
      });

    // OCC specific user id handling. Customize when implementing different backend
  }

  checkExistingPassword(params): Observable<any> {
    return this.baseService.post('customer-register/janrain-login', params);
  }

  forgotPasswordLink(params): Observable<any> {
    return this.baseService.post('customer-register/forgotPasswordEmail', params);
  }

  resetPassword(params): Observable<any> {
    return this.baseService.post('customer-register/resetPassword?', params)
  }
}